<div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0 py-15">
    <div class="row mb-5">
        <div class="col d-flex justify-content-center">
            <p class="mb-0 fs-12 ls-1 fw-700 text-uppercase font-secondary">{{ 'CONFIGURATOR.example_configs' | translate }}</p>
        </div>
    </div>

    <div class="d-none d-sm-block">
        <div #swiper class="swiper" [class.is-client]="isClient">
            <div class="swiper-wrapper">
                @for (snapshot of snapshots; track snapshot) {
                    <div class="swiper-slide">
                        <a [routerLink]="['.', { snapshot: snapshot.snapshotId }]">
                            <div class="item bg-white px-md-9 px-6 py-4 border">
                                <div>
                                    <img class="img-fluid" [src]="snapshot.image.url" alt="" />
                                </div>
                                <div class="label text-secondary text-uppercase fs-11 ls-1 lh-1 fw-700 font-secondary py-3">
                                    {{ 'BUTTONS.choose' | translate }}
                                </div>
                            </div>
                        </a>
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="d-sm-none">
        <div class="row gx-3">
            @for (snapshot of snapshots; track snapshot) {
                <div class="col-6 mb-3">
                    <a [routerLink]="['.', { snapshot: snapshot.snapshotId }]">
                        <div class="item bg-white px-md-9 px-6 py-4 border">
                            <div>
                                <img class="img-fluid" [src]="snapshot.image.url" alt="" />
                            </div>
                            <div class="label text-secondary text-uppercase fs-11 ls-1 lh-1 fw-700 font-secondary py-3">
                                {{ 'BUTTONS.choose' | translate }}
                            </div>
                        </div>
                    </a>
                </div>
            }
        </div>
    </div>

    <!-- Pagination -->
    <div #swiperPagination class="configurator-exapmles-pagination pagination pt-8 d-none d-sm-block"></div>
</div>
